import styled from '@emotion/styled';

export const RecordsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
